module.exports = __webpack_public_path__ + "static/media/02-banner-02-santa-fe-mobile@2x.399d3b3f.jpg";